import React, { Component } from 'react';
import { connect } from 'react-redux';
import Login from '../Login';

import { userLogout } from '../../actions/loginForms';

class Logout extends Component {

  componentDidMount() {
    this.props.userLogout()
  }

  render() {
    return (
      <Login />
    );
  }
}

export default connect(null, { userLogout })(Logout);



// WEBPACK FOOTER //
// ./src/containers/Logout/Logout.js